import { Dialog, DialogContent } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import FooterLinks from './components/FooterLinks';
import HeaderSection from './components/HeaderSection';
import ShareModalTab from './components/ShareModalTab';
import useStyles from './styles';

const ShareMyPageModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ className: classes.dialogPaper }}
    >
      <DialogContent className={classes.dialogContent}>
        <HeaderSection
          title={t('share_my_page_modal_title')}
          onClose={onClose}
          classes={classes}
        />

        <ShareModalTab
          classes={classes}
          onClose={onClose}
        />

        <FooterLinks
          classes={classes}
          t={t}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ShareMyPageModal;
